import { render, staticRenderFns } from "./EditCajaRegalo.vue?vue&type=template&id=d99cfe5e"
import script from "./EditCajaRegalo.vue?vue&type=script&lang=js"
export * from "./EditCajaRegalo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports